import React from 'react';
import TablaContacto from '../../components/tables/Contacto';

const Contacto = () => {
    return (
        <TablaContacto/>
    );
}
 
export default Contacto;